import React from 'react';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { Checkbox, FormGroup, FormControlLabel, Typography } from '@mui/material';

import MapPieChart from './MapPieChart';

import { DISEASES_COLORS } from './Const/colors';
import { query } from '../Database';
import TimeLineChart from './TimeLineChart';
import { HighChartsConvertMapPieData, HighChartsConvertLineData } from '../FormatData/HighChartsConvertData';
import mapDataZone from './Const/mapDataZone';
import mapDataThailand from './Const/mapDataThailand';
import DrillDownDropBox from './DrillDownDropBox';

import { viewtypes, yAxisTitle, gridLinesAmount, ZOOM, chart_query_str_dictionary, zone_all } from './Const/label';

import { useNavigate, useLocation, useParams, Link } from 'react-router-dom';
import StackBarChart from './StackBarChart';

class Dashboard extends React.Component {
    default_date_range() {
        const today = new Date();

        const today_month = ("0" + (today.getMonth() + 1)).slice(-2)
        const today_date = ("0" + today.getDate()).slice(-2)
        const edate = today.getFullYear() + today_month + today_date;
        const sdate = (today.getFullYear() - 1) + today_month + today_date;

        return { sdate, edate }
    }

    constructor(props) {
        super(props);
        console.log('constuct', props)

        const { viewtype, start, end, zone, province, hospital } = props.params;
        const { sdate, edate } = this.default_date_range();
        const zoom = ZOOM.filter((item) => item.id === zone || item.id === province)[0]

        this.state = {
            view: viewtype === undefined ? viewtypes.filter((item) => item.default)[0].value : viewtype,
            sdate: start === undefined ? sdate : start,
            edate: end === undefined ? edate : end,
            except_diseases: props.location.state ? props.location.sdate.except_diseases : [],
            zone: zone,
            province: province,
            hospital: hospital,
            zoom: zoom === undefined ? [1] : zoom.zoom,
            is_loading: true,
        };
    }

    get_week_of_year(date) {
        var oneJan = new Date(date.getFullYear(), 0, 1);
        var numberOfDays = Math.floor((date - oneJan) / (24 * 60 * 60 * 1000));
        return Math.ceil((date.getDay() + 1 + numberOfDays) / 7);
    }

    async get_data(view, start, end, zone, province, hospital) {
        // กำหนด Variable time: view, start: start, end: end
        const sdate = new Date(start.slice(0, 4) + '-' +
            start.slice(4, 6) + '-' +
            start.slice(6, 8));
        const edate = new Date(end.slice(0, 4) + '-' +
            end.slice(4, 6) + '-' +
            end.slice(6, 8));
        var sunit, eunit, syear, eyear = edate.getFullYear()
        if (view === viewtypes[0].value) {
            sunit = ("0" + this.get_week_of_year(sdate).toString()).slice(-2)
            eunit = ("0" + this.get_week_of_year(edate).toString()).slice(-2)
            syear = sdate.getFullYear()
            eyear = edate.getFullYear()
        }
        else if (view === viewtypes[1].value) {
            sunit = ("0" + (sdate.getMonth() + 1)).slice(-2)
            eunit = ("0" + (edate.getMonth() + 1)).slice(-2)
            syear = sdate.getFullYear()
            eyear = edate.getFullYear()
        }
        else if (view === viewtypes[2].value) {
            sunit = Math.floor((sdate.getMonth() + 3) / 3).toString()
            eunit = Math.floor((edate.getMonth() + 3) / 3).toString()
            syear = sdate.getFullYear()
            eyear = edate.getFullYear()
        }
        else if (view === viewtypes[3].value) {
            sunit = '';
            eunit = '';
            syear = sdate.getFullYear()
            eyear = edate.getFullYear()
        }

        const squery = parseInt(syear + sunit)
        const equery = parseInt(eyear + eunit)
        const sformat = "Y" + syear + (view === 'Y' ? '' : view + sunit)
        const eformat = "Y" + eyear + (view === 'Y' ? '' : view + eunit)

        var variables_timeline = { time: view, start: squery, end: equery }
        var variables_piechart = { time: view, start: squery, end: equery }
        var variables_hospital_timeline = { time: view, start: squery, end: equery }


        //กำหนด query name ตาม keytype
        const key = province ? 'province' : zone ? 'zone' : 'all'
        const query_str = chart_query_str_dictionary[key]
        console.log('getdata!!!!', view, start, end, zone, province, hospital)

        if (province) {
            variables_timeline.province = province
            variables_piechart.province = province
        } else if (zone) {
            variables_timeline.zone = zone
            variables_piechart.zone = zone
        }

        const query_str_hospital = chart_query_str_dictionary.hospital.timeline
        if (hospital) {
            variables_hospital_timeline.hospital = hospital
        }

        const result_timeline = await query(query_str.timeline, variables_timeline)

        const result_piechart = await query(query_str.pie, variables_piechart)

        const data_timeline = HighChartsConvertLineData(result_timeline, this.state.except_diseases, view)

        const data_piechart = HighChartsConvertMapPieData(result_piechart, this.state.except_diseases)

        const data_treemap = HighChartsConvertLineData(result_piechart, this.state.except_diseases)


        const result_timeline_hospital = hospital && await query(query_str_hospital, variables_hospital_timeline)

        const data_timeline_hospital = result_timeline_hospital && HighChartsConvertLineData(result_timeline_hospital, this.state.except_diseases, view)

        const zoom = ZOOM.filter((item) => item.id === zone || item.id === province)[0]

        this.setState({
            result_timeline: result_timeline,
            result_piechart: result_piechart,
            timelinedata: data_timeline,
            piechartdata: data_piechart,
            treemapdata: data_treemap,

            result_timeline_hospital: result_timeline_hospital,
            hospitaldata: data_timeline_hospital,

            startformat: sformat,
            endformat: eformat,

            view: view,
            sdate: start,
            edate: end,
            zone: zone,
            province: province,
            hospital: hospital,

            zoom: zoom === undefined ? [1] : zoom.zoom,
            is_loading: false,
        })
    }

    componentDidMount() {
        this.get_data(
            this.state.view,
            this.state.sdate,
            this.state.edate,
            this.state.zone,
            this.state.province,
            this.state.hospital
        )
    }

    componentDidUpdate(prevProps, prevStates, snapshot) {
        if (prevProps.location !== this.props.location) {
            console.log('update', this.props)
            // if (prevProps.match.url !== this.props.match.url) {
            const { viewtype, start, end, zone, province, hospital } = this.props.params;
            console.log("Update=====", viewtype, start, end, zone, province, hospital)
            const { sdate, edate } = this.default_date_range();

            this.setState({
                is_loading: true
            })
            this.get_data(
                viewtype === undefined ? viewtypes.filter((item) => item.default)[0].value : viewtype,
                start === undefined ? sdate : start,
                end === undefined ? edate : end,
                zone,
                province,
                hospital
            )
        }
    }

    changezone(zone) {
        const path =
            '/' + this.state.view +
            '/' + this.state.sdate +
            '/' + this.state.edate +
            '/' + zone
        this.props.navigate({
            pathname: path,
            state: { except_diseases: this.state.except_diseases },
            // search: createSearchParams({ except_diseases: this.state.except_diseases }).toString()
        });
    }

    changeprovince(province) {
        const path =
            '/' + this.state.view +
            '/' + this.state.sdate +
            '/' + this.state.edate +
            '/' + this.state.zone +
            '/' + province

        this.props.navigate({
            pathname: path,
            state: { except_diseases: this.state.except_diseases },
            // search: createSearchParams({ except_diseases: this.state.except_diseases }).toString()
        });
    }

    changeview(view) {
        const path =
            '/' + view +
            '/' + this.state.sdate +
            '/' + this.state.edate +
            (this.state.zone ? '/' + this.state.zone + (this.state.province ? '/' + this.state.province : '') : '')

        this.props.navigate({
            pathname: path,
            state: { except_diseases: this.state.except_diseases },
            // search: createSearchParams({ except_diseases: this.state.except_diseases }).toString()
        });
    }

    changedate(type, date) {
        const path =
            '/' + this.state.view +
            '/' + (type === 's' ? date : this.state.sdate) +
            '/' + (type === 'e' ? date : this.state.edate) +
            (this.state.zone ? '/' + this.state.zone + (this.state.province ? '/' + this.state.province : '') : '')

        this.props.navigate({
            pathname: path,
            state: { except_diseases: this.state.except_diseases },
            // search: createSearchParams({ except_diseases: this.state.except_diseases }).toString()
        });
    }

    drilldown_map(element) {
        if (!this.state.zone) {
            // ส่ง zone ID มาให้
            const path =
                '/' + this.state.view +
                '/' + this.state.sdate +
                '/' + this.state.edate +
                '/' + element

            this.props.navigate({
                pathname: path,
                state: { except_diseases: this.state.except_diseases },
                // search: createSearchParams({ except_diseases: this.state.except_diseases }).toString()
            });

        } else if (!this.state.province) {
            // ส่ง province มาให้
            const path =
                '/' + this.state.view +
                '/' + this.state.sdate +
                '/' + this.state.edate +
                '/' + this.state.zone +
                '/' + element

            this.props.navigate({
                pathname: path,
                state: { except_diseases: this.state.except_diseases },
                // search: createSearchParams({ except_diseases: this.state.except_diseases }).toString()
            });

        }
    }

    changehospital(element) {
        const path =
            '/' + this.state.view +
            '/' + this.state.sdate +
            '/' + this.state.edate +
            '/' + this.state.zone +
            '/' + this.state.province +
            '/' + element

        this.props.navigate({
            pathname: path,
            state: { except_diseases: this.state.except_diseases },
            // search: createSearchParams({ except_diseases: this.state.except_diseases }).toString()
        });

    }

    set_diseases_display(disease) {
        var except_diseases = this.state.except_diseases

        var index = except_diseases.indexOf(disease);
        if (index !== -1) {
            except_diseases.splice(index, 1);
        } else {
            except_diseases.push(disease)
        }

        const data_timeline = HighChartsConvertLineData(this.state.result_timeline, except_diseases, this.state.view)

        const data_piechart = HighChartsConvertMapPieData(this.state.result_piechart, except_diseases)

        const data_treemap = HighChartsConvertLineData(this.state.result_piechart, except_diseases)

        const data_timeline_hospital = this.state.result_timeline_hospital && HighChartsConvertLineData(this.state.result_timeline_hospital, this.state.except_diseases, this.state.view)

        this.setState({
            except_diseases: except_diseases,
            timelinedata: data_timeline,
            piechartdata: data_piechart,
            treemapdata: data_treemap,
            hospitaldata: data_timeline_hospital,
        })
    }

    render() {
        if (this.state.timelinedata !== undefined &&
            this.state.piechartdata !== undefined &&
            this.state.treemapdata !== undefined
        ) {
            const timelinedata = this.state.timelinedata;
            const piechartdata = this.state.piechartdata;
            const treemapdata = this.state.treemapdata;
            return (
                <div style={{ width: '100%', height: '100%' }}>
                    {this.state.is_loading && <div style={{ opacity: 0.8, backgroundColor: '#ccc', position: 'fixed', width: '100%', height: '100%', top: 0, left: 0, zIndex: 1000, fontSize: 50, textAlign: 'center', verticalAlign: 'middle' }}>Loading...</div>}
                    <div style={{ fontSize: '11px', }}>
                        {/* Start: {this.state.startformat}&nbsp;
                    End: {this.state.endformat}&nbsp; */}
                        {/* Display information of&nbsp; */}

                        {/* เลือก province ไว้ จะแสดง Treemap
                    bind(xxx) คือตอนที่ function drilldown ถูกเรียก จะทำให้การอ้าง this ในฟังก์ชั่น drilldown
                    จะเป็นค่าใน scope ของ xxx (ในที่นี้คือ class dashboard)
                    ไม่ใช่ scope ของ global (จุดที่เรียก function ในที่นี้คือ DrillDownDropBox) */}
                        {/* <DrillDownDropBox
                        changezone={this.changezone.bind(this)}
                        changeprovince={this.changeprovince.bind(this)}
                        changehospital={this.changehospital.bind(this)}
                        zone={this.state.zone}
                        province={this.state.province}
                        hospital={this.state.hospital}
                    />&nbsp; */}
                        <Link
                            to={'/' + this.state.view +
                                '/' + this.state.sdate +
                                '/' + this.state.edate}
                        >{zone_all.label}</Link>
                        {this.state.zone &&
                            <label>&nbsp;&gt;&nbsp;
                                <Link
                                    to={'/' + this.state.view +
                                        '/' + this.state.sdate +
                                        '/' + this.state.edate +
                                        '/' + this.state.zone}
                                >{this.state.zone}</Link>
                            </label>
                        }
                        {this.state.province &&
                            <label>&nbsp;&gt;&nbsp;
                                <Link
                                    to={'/' + this.state.view +
                                        '/' + this.state.sdate +
                                        '/' + this.state.edate +
                                        '/' + this.state.zone +
                                        '/' + this.state.province}
                                >{this.state.province}</Link>
                            </label>
                        }
                        <div style={{
                            float: 'right',
                            width: '50%',
                            display: 'grid',
                            gridTemplateRows: '450px',
                            gridTemplateColumns: '50%',
                            gridTemplateAreas: `'top top'
                        'left right'`
                        }}>
                            <div style={{ gridArea: 'top' }}>
                                <TimeLineChart
                                    title={this.state.province ?
                                        this.state.province :
                                        this.state.zone ?
                                            this.state.zone :
                                            zone_all.label
                                    }
                                    yAxisTitle={yAxisTitle}
                                    xAxisTitle={viewtypes.filter((item) => item.value === this.state.view)[0].label}
                                    gridLinesAmount={gridLinesAmount}
                                    data={timelinedata}
                                    height='450px'
                                />
                            </div>
                            <div style={{ gridArea: 'left' }}>
                                <FormGroup>
                                    {DISEASES_COLORS.map((disease_color) => {
                                        return <FormControlLabel
                                            key={disease_color.disease}
                                            control={<Checkbox
                                                id={disease_color.disease}
                                                value={disease_color.disease}
                                                onChange={() => { this.set_diseases_display(disease_color.disease); }}
                                                defaultChecked
                                                sx={{
                                                    '&.Mui-checked': {
                                                        color: disease_color.color,
                                                        backgroundColor: 'DimGray',
                                                        margin: 0,
                                                        padding: 0,
                                                    },
                                                }}
                                                style={{
                                                    transform: 'scale(0.8)',
                                                    margin: 0,
                                                    padding: 0,
                                                    height: 16,
                                                    width: 16,
                                                }}
                                            />}
                                            label={
                                                <Typography style={{ fontSize: '11px' }}>
                                                    {disease_color.disease}
                                                </Typography>
                                            } />
                                    })}
                                </FormGroup>
                            </div>
                            <div style={{ gridArea: 'right' }}>
                                View by:
                                <select
                                    value={this.state.view}
                                    onChange={e => this.changeview(e.target.value)}>
                                    {viewtypes.map((item) => {
                                        return <option key={item.value} value={item.value}>{item.label}</option>
                                    })}
                                </select>
                                <br />
                                Start:
                                <DatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selected={new Date(this.state.sdate.slice(0, 4) + '-' +
                                        this.state.sdate.slice(4, 6) + '-' +
                                        this.state.sdate.slice(6, 8))}
                                    onChange={(date) => this.changedate('s',
                                        [date.getFullYear(),
                                        ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1),
                                        (date.getDate() > 9 ? '' : '0') + date.getDate()
                                        ].join(''))
                                    }
                                />
                                End:
                                <DatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selected={new Date(this.state.edate.slice(0, 4) + '-' +
                                        this.state.edate.slice(4, 6) + '-' +
                                        this.state.edate.slice(6, 8))}
                                    onChange={(date) => this.changedate('e',
                                        [date.getFullYear(),
                                        ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1),
                                        (date.getDate() > 9 ? '' : '0') + date.getDate()
                                        ].join(''))
                                    }
                                />
                            </div>
                        </div>
                        <div style={{ float: 'left', width: '48%' }}>
                            {/* เลือก province ไว้ จะแสดง Treemap
                        bind(xxx) คือตอนที่ function drilldown ถูกเรียก จะทำให้การอ้าง this ในฟังก์ชั่น drilldown
                        จะเป็นค่าใน scope ของ xxx (ในที่นี้คือ class dashboard)
                        ไม่ใช่ scope ของ global (จุดที่เรียก function ในที่นี้คือ TreemapChart หรือ MapPieChart) */}

                            {/* เลือก province ไว้ จะแสดง Treemap */}
                            <StackBarChart
                                key='hospital' id='hospital'
                                display={this.state.province}
                                changehospital={this.changehospital.bind(this)}
                                data={treemapdata}
                                height={this.state.hospital ? '380px' : '600px'}
                                hospital={this.state.hospital}
                            />
                            {this.state.hospital
                                &&
                                <TimeLineChart
                                    title={this.state.hospital}
                                    yAxisTitle={yAxisTitle}
                                    xAxisTitle={viewtypes.filter((item) => item.value === this.state.view)[0].label}
                                    gridLinesAmount={gridLinesAmount}
                                    data={this.state.hospitaldata}
                                    height='220px'
                                />
                            }
                            {/* เลือก zone ไว้ จะแสดง map ของแต่ละจังหวัด */}
                            <MapPieChart
                                key='zone' id='zone'
                                display={!this.state.zone && !this.state.province}
                                drilldown={this.drilldown_map.bind(this)}
                                zoom={this.state.zoom}
                                map={mapDataZone}
                                data={piechartdata}
                                height='600px' />
                            {/* ไม่ได้เลือก zone ไว้ จะแสดง map ของแต่ละเขตสุขภาพ */}
                            <MapPieChart
                                key='province' id='province'
                                display={this.state.zone && !this.state.province}
                                drilldown={this.drilldown_map.bind(this)}
                                zoom={this.state.zoom}
                                map={mapDataThailand}
                                data={piechartdata}
                                height='600px' />

                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div style={{ opacity: 0.8, backgroundColor: '#ccc', position: 'fixed', width: '100%', height: '100%', top: 0, left: 0, zIndex: 1000, fontSize: 50, textAlign: 'center', verticalAlign: 'middle' }}>Loading...</div>
        );
    }
}

// WithNavigate returns a component that wraps ChildComponent and passes in the navigation prop
function WithNavigate(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    return <Dashboard {...props} navigate={navigate} location={location} params={params} />
}
export default WithNavigate;